import { useLocation } from 'react-router-dom';
import { ContentTemplate, TitleHeader } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as QUERIES from '../../../api/candidate/resit/@opadmin/queries-services/queries';
import RegisteredCandidateDetails from '../../../modules/resit/components/@opadmin/RegisteredCandidateDetails';

const OopAdminRegisteredCandidateDetails = () => {
  const { state } = useLocation();
  const { t } = useTranslation();

  // @ts-ignore
  const { data } = QUERIES.useGetIndividualCandidateRegistration(state && state.indexNo, {
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    retryOnMount: true,
    // @ts-ignore
    enabled: state && state.indexNo >= 0,
  });

  return (
    <>
      <TitleHeader title={t('resit->>OpAdminResit.Candidate Registration Details')} />
      {data && (
        <ContentTemplate>
          <RegisteredCandidateDetails candidateDetail={data} />
        </ContentTemplate>
      )}
    </>
  );
};
export default OopAdminRegisteredCandidateDetails;
